import { Component } from '@angular/core';
import { UsersList } from '../../../../components/admin-dashboard-component/user-management/users-list/users-list';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-view-users',
  imports: [UsersList, RouterLink],
  templateUrl: './view-users.html',
  styleUrl: './view-users.scss',
})
export class ViewUsers {}
